// extracted by mini-css-extract-plugin
export default {"socials":"SocialLinks_socials__5e6hy","container":"SocialLinks_container__NKTdx","ring":"SocialLinks_ring__k3S6c"};